import { escapeHTML as esc } from '../core/utils.js';

export function catalogResources(entry) {
  if (!entry?.resources?.length) return '';
  return `<details class="catalog-resources"><summary>${entry.practice ? 'About the piano arrangement' : 'Music &amp; note sources'}</summary><p>${esc(entry.practiceNote)}</p><ul>${entry.resources.map(resource => `<li><a href="${esc(resource.url)}" target="_blank" rel="noopener noreferrer">${esc(resource.title)}</a><small>${esc(resource.description)}</small></li>`).join('')}</ul></details>`;
}
